import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { ApiService, ViewPoint, Visualize3dObject } from 'projects/visualize3d/src/public-api';
import { ImportV3dObject } from '../../models/import-v3d-object';
import { HtmlInputEvent } from '../../models/html-input-event';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  standalone: false,
})
export class AppMenuComponent {
  api = inject(ApiService);

  @Output() addV3dObject = new EventEmitter<void>();
  @Output() deleteV3dObject = new EventEmitter<void>();
  @Output() viewChange = new EventEmitter<ViewPoint>();
  @Output() fitChange = new EventEmitter<boolean>();
  @Output() export = new EventEmitter<string>();
  @Output() importV3dObject = new EventEmitter<ImportV3dObject>();
  @Output() refresh = new EventEmitter<void>();
  @Output() preferences = new EventEmitter<void>();
  @Output() about = new EventEmitter<void>();
  @Output() orthographicView = new EventEmitter<boolean>();
  @Input() selectedV3dObject: Visualize3dObject;

  @ViewChild('import', { static: true }) importFile: ElementRef;

  viewPoint = ViewPoint;

  enumKeys(enumType: Record<string, unknown>): string[] {
    return Object.keys(enumType).filter(type => isNaN(type as any) && type !== 'values');
  }

  fileChanged(event: HtmlInputEvent): void {
    const handleError = (error: any): void => {
      this.importV3dObject.emit({
        v3dObject: null,
        fileName: null,
        error,
      });
    };
    try {
      if (!event.target.files || event.target.files.length !== 1) {
        return;
      }
      const file = event.target.files[0];
      const fileReader = new FileReader();
      fileReader.onload = (): void => {
        try {
          const json = JSON.parse(fileReader.result as string);
          const object3d = json as Visualize3dObject;
          this.importV3dObject.emit({
            v3dObject: object3d,
            fileName: file.name,
            error: null,
          });
        } catch (error) {
          handleError(error.message);
        }
      };
      fileReader.readAsText(file, 'UTF-8');
    } catch (error) {
      handleError(error.message);
    } finally {
      this.importFile.nativeElement.value = null;
    }
  }
}
